export const SettingsData = {
  userInterface: {
    label: "User Interface Settings",
    settings: [
      {
        id: "showUserProfile",
        label: "Show User Profile",
        description: "Allow users to view and edit their profiles",
        type: "toggle",
        defaultValue: true
      }
    ]
  },
  content: {
    label: "Content Management",
    settings: [
      {
        id: "blogPosts",
        label: "Blog Posts",
        description: "Enable blog section",
        type: "toggle",
        defaultValue: true
      },
      {
        id: "playlistsection",
        label: "Playlist Section",
        description: "Allow admins to control over playlist",
        type: "toggle",
        defaultValue: true
      },
      {
        id: "bookssection",
        label: "Books Section",
        description: "Allow admins to control over Books",
        type: "toggle",
        defaultValue: true
      },
      {
        id: "audiosection",
        label: "Audio Section",
        description: "Allow admins to control over Audio",
        type: "toggle",
        defaultValue: true
      },
      {
        id: "videosection",
        label: "Video Section",
        description: "Allow admins to control over Video",
        type: "toggle",
        defaultValue: true
      },
      {
        id: "shortvideosection",
        label: "Short Video Section",
        description: "Allow admins to control over Short Videos",
        type: "toggle",
        defaultValue: true
      }
    ]
  }
};